import { useMobileRedirectedPage } from "@/hooks/useMobileRedirectedPage";
import { AreaPage } from "./AreaPage";

export const AreaMobilePage = () => {
  const isMobileRedirected = useMobileRedirectedPage();

  if (!isMobileRedirected) {
    return <div>Not enough data to redirect</div>;
  }

  return (
    <div style={{ width: document.documentElement.clientWidth, height: document.documentElement.clientHeight }}>
      <AreaPage />
    </div>
  );
};
